import './Footer.scss'

export default function Footer() {
	return null;
}
